import { render, staticRenderFns } from "./registration-form-view.vue?vue&type=template&id=a91a0116&scoped=true&"
import script from "./registration-form-view.vue?vue&type=script&lang=js&"
export * from "./registration-form-view.vue?vue&type=script&lang=js&"
import style0 from "./registration-form-view.vue?vue&type=style&index=0&id=a91a0116&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a91a0116",
  null
  
)

export default component.exports